import api from "app/lib/api";
import endpoints from "static/endpoints";

export const fetchDeviceTypes = async (includeHF = false) => {
  let url = endpoints.deviceTypes.fetchDeviceTypes;

  if (includeHF) url += `?includeHF=${includeHF}`;

  const { data } = await api.get(url);
  return data;
};
